module.exports = "/_next/static/images/39194dab9e9749741140d26e911624aa-rewards-home-card@2x.png";